import { batchHiddenActions } from 'Reducers/batchReducer';
import { getComponents } from 'Selectors';

const REGEX_FOR_GETTING_HREF_ATTR_IN_STRING = /<link.+?href="([^"]+)/;
export const fontAPIKey = 'AIzaSyDThCWNVJCP4K5OKnEEBsvhcVnDFfI8WcA'
export const fontAPIUrl = `https://www.googleapis.com/webfonts/v1/webfonts?key=${fontAPIKey}`
export const fontHREF = 'https://fonts.googleapis.com/css?family={FAMILY}:{WEIGHT}';
export const fontStyleTag = '<link href="{fontHREF}" rel="stylesheet">';
export const fontImport = '@import url("https://fonts.googleapis.com/css?family={FAMILY}&text={FAMILY}");';

const chunk = (ar, size) => {
  let buffer = [];
  return ar.reduce((acc, item, i) => {
    const isLast = i === ar.length - 1;
    if (buffer.length === size) {
      const theChunk = [...buffer];
      buffer = [item];
      return [...acc, theChunk];
    }
    buffer.push(item);
    if (isLast) return [...acc, buffer];
    return acc;
  }, []);
};

const addFont = font => ({
  type: 'ADD_FONT',
  font,
});

const addFontWeights = (fontWeights, parentId) => ({
  type: 'ADD_FONT_WEIGHTS',
  fontWeights,
  parentId,
});

const addFontInUse = font => ({
  type: 'ADD_ACTIVE_FONT',
  font,
});

const addFontStyles = (fonts) => {
  const unique = (value, index, self) => self.indexOf(value) === index;
  const chunkedFonts = chunk(fonts, 14);
  const importStatements = chunkedFonts
    .map((chunkedFontsArr) => {
      return `@import "https://fonts.googleapis.com/css?family=${chunkedFontsArr
        .map(f => f.family)
        .join('|')}&display=swap&text=${chunkedFontsArr.map(f => f.family.split('')).flat().filter(unique).join('')}"`;
    })
    .join(';');

  const fontsStyle = document.createElement('style');
  fontsStyle.type = 'text/css';
  fontsStyle.innerHTML = importStatements;
  document.getElementsByTagName('head')[0].appendChild(fontsStyle);
};

const addDefaultFonts = dispatch => (fonts) => {
  const availableFonts = fonts.items;
  addFontStyles(availableFonts);
  const action = availableFonts.reduce((memo, font) => ([
    ...memo,
    addFont(font),
    addFontWeights(font.variants, font.family),
  ]), []);
  dispatch(batchHiddenActions(action));
};

const getHrefFromHTMLString = html =>
  html.match(REGEX_FOR_GETTING_HREF_ATTR_IN_STRING)[1];

export const loadDefaultFonts = (dispatch) => {
  fetch(fontAPIUrl, { // eslint-disable-line no-undef
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.json()).then(addDefaultFonts(dispatch));
};

const fetchFontHTMLFromfonts = (dispatch, fontId, callback = () => {}) => {
  const fontFamily = fontId.split('____')[0];
  const fontWeight = fontId.split('____')[1];
  const href = fontHREF.replace('{FAMILY}', fontFamily).replace('{WEIGHT}', fontWeight);
  const html = fontStyleTag.replace('{fontHREF}', href);
  const font = {
    html,
    href,
    id: fontId,
  };
  dispatch(addFontInUse(font));
  callback(fontId);
};

export const fetchFontHTML = fontId => (dispatch) => {
  const p = new Promise((resolve) => {
    fetchFontHTMLFromfonts(dispatch, fontId, font => resolve(font));
  });
  return p;
};

const fetchFontInfoFromfonts = (dispatch, fontId, callback) => {
  WFP.getFontByID(fontId, (info) => { // eslint-disable-line no-undef
    dispatch(addFont(info));
    dispatch(addFontWeights(info.fonts, info.id));
    callback(info);
  });
};

export const fetchFontInfo = fontId => (dispatch) => {
  const p = new Promise((resolve) => {
    fetchFontInfoFromfonts(dispatch, fontId, info => resolve(info));
  });
  return p;
};

const getUniqueFontWeightIds = (getState) => {
  const components = getComponents(getState());
  const componentsFontWeightIds = components.map(c => c.getFontWeightId()).filter(id => id);
  return componentsFontWeightIds.toSet().toList();
};

export const fetchFontsInUse = () => (dispatch, getState) => {
  const componentsFontWeightIds = getUniqueFontWeightIds(getState);
  componentsFontWeightIds.forEach(fontWeightId =>
    fetchFontHTMLFromfonts(dispatch, fontWeightId));
};



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/actions/fontActions.js